// Colour roles for an InfoCallout fact badge. Each one is the colour the control that
// drives the number already wears in the form below — a ticked .cbx checkbox is navy, a
// switched-on .switch toggle is green — so the note reads as a legend for the form rather
// than as a wall of numbers. Neutral is for a figure no control gates.
const InfoCalloutToneEnum = {
  Navy: 'navy',
  Green: 'green',
  Neutral: 'neutral',
};

export default InfoCalloutToneEnum;
